var __jsx = React.createElement;
import React, { memo } from "react";
import SessionTimeout from "components/fragments/global/SessionTimeout/SessionTimeout";
import GlobalFooter from "../../Footer/GlobalFooter";
import Feedback from "../../Footer/Feedback";
import styles from "../Layout.module.scss";
function Footer(_ref) {
  var isPublic = _ref.isPublic;
  return /*#__PURE__*/React.createElement("footer", {
    className: styles.ev__footer
  }, /*#__PURE__*/React.createElement(GlobalFooter, null), /*#__PURE__*/React.createElement(Feedback, null), !isPublic && /*#__PURE__*/React.createElement(SessionTimeout, null));
}
export default /*#__PURE__*/memo(Footer);